export default {
  'component.delBtn.title': 'Are you sure to delete?',
  'component.delBtn.tooltip': 'Delete',
};
